module.exports = __webpack_public_path__ + "static/media/upload_csv.ac8fd18b.svg";